import { useEffect, useState } from "react"
import FooterPartener from "../commun/FooterPartener";
import { setUserCookies, userIsConnected } from "../../utils/user";

export default function Login(){

    const [login, setLogin] = useState('');
    const [password, setPassword] = useState('');
    const [msg, setMsg] = useState('');

    const log = ()=>{
        if(login === 'europeanmeeting' && password === 'Madrid2024'){
            setUserCookies();
            window.location.href= '/dashboard';
        }else{
            setMsg('Error: invalid login');
        }
    }

    useEffect(()=>{
        if(userIsConnected()){
            window.location.href= '/dashboard';
        }
    },[]);

    return(
        <div className="login-page">
            <div className="container">
                <div className="form-login position-absolute top-50 start-50 translate-middle text-center c-white">
                    <img alt="Logo" src="./assets/title-login.png" width={'100%'} height={'auto'} />
                    <h1>Login</h1>
                    <input className="input-control" type="text" placeholder="Login" value={login} onChange={(e)=>{setLogin(e.target.value)}} />
                    <input className="input-control" type="password" placeholder="Password" value={password} onChange={(e)=>{setPassword(e.target.value)}} />
                    <br />
                    <p className="err mt-1">
                        {msg}
                    </p>
                    <button onClick={()=>{log()}} className="btn-control mt-1">
                        Enter
                    </button>
                    <p className="mt-3">
                        Plenary Meeting, Madrid
                        <br />
                        15-17 November 2024
                    </p>
                </div>
            </div>
            <FooterPartener/>
        </div>

    )
}